export default {
      id: "sli-reorder-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-reorder",
      toString: function () {
        return this.url;
      }
    }